import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlePreview() {
  const recentArticles = articles.slice(0, 3);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14 gap-4">
          <div>
            <span className="inline-block px-3.5 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold font-label mb-4">
              最新文章
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              探索更多技巧
            </h2>
          </div>
          <Link
            to="/category/browser-tips"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {recentArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-background-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">{article.readTime}阅读</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-base leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}